"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSpriteWithDynamicBody = isSpriteWithDynamicBody;
function isSpriteWithDynamicBody(body) {
  return (body === null || body === void 0 ? void 0 : body.physicsType) === Phaser.Physics.Arcade.DYNAMIC_BODY;
}